import Vue from 'vue'
import Router from 'vue-router'

import PageDatetimePicker from '../pages/ui/datetime-picker'
import PageSkeletonLoader from '../pages/content/skeleton-loader'
import PageComingSoon from '../pages/coming-soon'
import PageAlert from '../pages/ui/alert'
import PageCollapsible from '../pages/ui/collapsible'
import PageIndex from '../pages/index'
import PageTab from '../pages/ui/tab'
import PageIcon from '../pages/ui/icon'
import PageNavbar from '../pages/ui/navbar'
import PageProgressbar from '../pages/ui/progressbar'
import PagePager from '../pages/ui/pager'
import PageChip from '../pages/ui/chip'
import PageCard from '../pages/ui/card'
import PageCarousel from '../pages/ui/carousel'
import PageFlex from '../pages/content/flex'
import PageColors from '../pages/content/colors'
import PageAsyncForm from '../pages/forms/async-form'
import PageBtn from '../pages/ui/btn'
import PageMenuList from '../pages/ui/menu-list'
import PageList from '../pages/ui/list'
import PageFab from '../pages/ui/fab'
import PageToolbar from '../pages/ui/toolbar'
import PageDialogBox from '../pages/ui/dialog-box'
import PageLoadingOverlay from '../pages/ui/loading-overlay'
import PageSnackbar from '../pages/ui/snackbar'
import PageBottomSheets from '../pages/ui/bottom-sheets'
import PageBottomNavigation from '../pages/ui/bottom-navigation'
import PageRadioGroup from '../pages/forms/radio-group'
import PageCheckbox from '../pages/forms/checkbox'
import PageSwitcher from '../pages/forms/switcher'
import PageQuickStart from '../pages/getting-started/quick-start'
import PageDevelopment from '../pages/getting-started/development'
import PageDeployment from '../pages/getting-started/deployment'
import PagePublishing from '../pages/getting-started/publishing'
import PageElevation from '../pages/content/elevation'
import PageResize from '../pages/directives/resize'
import PageRipple from '../pages/directives/ripple'
import PageTooltip from '../pages/directives/tooltip'
import PageBcqApp from '../pages/content/bcq-app'
import PageReusableCssClasses from '../pages/content/reusable-css-classes'
import PageContainer from '../pages/content/container'
import PageReactiveStyle from '../pages/content/reactive-style'
import PageSpacing from '../pages/content/spacing'
import PageTableLayout from '../pages/content/table-layout'
import PageTheme from '../pages/content/theme'
import PageTypography from '../pages/content/typography'
import PageApiExplorer from '../pages/ui/api-explorer'
import PageAvatar from '../pages/ui/avatar'
import PageDivider from '../pages/ui/divider'
import PageFlag from '../pages/ui/flag'
import PageBreadcrumbs from '../pages/ui/breadcrumbs'
import PageNightshift from '../pages/ui/nightshift'
import PageBadge from '../pages/ui/badge'
import PageDropdown from '../pages/forms/dropdown'
import PageLazyImage from '../pages/ui/lazy-image'
import PageLoremIpsum from '../pages/ui/lorem-ipsum'
import PageSection from '../pages/section'
import PageSitemap from '../pages/sitemap'
import PageRoadmap from '../pages/roadmap'
import PageBareboneProp from '../pages/content/barebone-prop'
import PageSearch from '../pages/search'
import PageTextField from '../pages/forms/text-field'
import PageLineRipple from '../pages/ui/line-ripple'
import PageDataTable from '../pages/ui/data-table'
import PageTimeline from '../pages/ui/timeline'
import PageRating from '../pages/ui/rating'
import PageCookieConsent from '../pages/ui/cookie-consent'
import PageTreeview from '../pages/ui/treeview'
import PageNotification from '../pages/ui/notification'
import PageCookiePolicy from '../pages/cookie-policy'
import PageBrandColor from '../pages/content/brand-color'
import PageColorPicker from '../pages/ui/color-picker'
import PageUpload from '../pages/forms/upload'
import PageGauge from '../pages/ui/gauge'
import PageSlider from '../pages/ui/slider'
import PageSystemBar from '../pages/ui/system-bar'
import PageBtnGroup from '../pages/ui/btn-group'
import PageParallax from '../pages/ui/parallax'
import PageTerminal from '../pages/ui/terminal'
import PageAspectRatio from '../pages/directives/aspect-ratio'
import PageSparklines from '../pages/ui/sparklines'
import PageSocialBar from '../pages/ui/social-bar'
import PageRibbon from '../pages/ui/ribbon'
import PageAmbientImage from '../pages/ui/ambient-image'
import PagePasswordGenerator from '../pages/ui/password-generator'
import PagePasswordStrengthMeter from '../pages/ui/password-strength-meter'
import PageContextMenu from '../pages/ui/context-menu'
import PageBcqBundler from '../pages/getting-started/bcq-bundler'
import PageOtpInput from '../pages/forms/otp-input'
import PageVid from '../pages/ui/vid'
import PageChipInput from '../pages/forms/chip-input'
import PageFormGroup from '../pages/forms/form-group'
import PageTimePicker from '../pages/ui/time-picker'
import PageTimePickerField from '../pages/forms/time-picker-field'
import PageQrCode from '../pages/ui/qr-code'
import PageGradientText from '../pages/directives/gradient-text'
import PageMultilineEllipsis from '../pages/ui/multiline-ellipsis'
import PageTransfer from '../pages/ui/transfer'
import PageEmpty from '../pages/ui/empty'
import PageInlineEditor from '../pages/ui/inline-editor'
import PageSteps from '../pages/ui/steps'
import PageStats from '../pages/ui/stats'
import PageNavigatorOnline from '../pages/content/navigator-online'
import PageBadgeGenerator from '../pages/ui/badge-generator'
import PageChordDiagram from '../pages/ui/chord-diagram'
import PageReflection from '../pages/ui/reflection'
import PageChessboard from '../pages/ui/chessboard'
import PageEmoji from '../pages/ui/emoji'
import PageFormSchema from '../pages/forms/form-schema'
import PageAutocomplete from '../pages/forms/autocomplete'
import PageClusteredList from '../pages/forms/clustered-list'
import PageClusteredList2 from '../pages/forms/clustered-list-2'
import PageMacosDock from '../pages/ui/macos-dock'
import PageVisibilityObserver from '../pages/content/visibility-observer'
import PageIntersect from '../pages/directives/intersect'
import PageBanner from '../pages/ui/banner'
import PageMetaTags from '../pages/content/meta-tags'
import PageStore from '../pages/content/store'
import PageReleaseNotes from '../pages/getting-started/release-notes'
import PageAppReleaseNotes from '../pages/content/app-release-notes'
import PageVisualFeedbackIcon from '../pages/ui/visual-feedback-icon'
import PageColorPalette from '../pages/ui/color-palette'
import PageThemeColors from '../pages/content/theme-colors'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    type: null,
    path: '/',
    name: 'page-index',
    component: PageIndex,
    title: 'Home'
  }, {
    type: null,
    path: '/roadmap',
    name: 'page-roadmap',
    component: PageRoadmap,
    title: 'Roadmap'
  }, {
    type: null,
    path: '/sitemap',
    name: 'page-sitemap',
    component: PageSitemap,
    title: 'Sitemap'
  }, {
    type: null,
    path: '/search',
    name: 'page-search',
    component: PageSearch,
    title: 'Search'
  }, {
    type: null,
    path: '/cookie-policy',
    name: 'page-cookie-policy',
    component: PageCookiePolicy,
    title: 'Cookie Policy'
  }, {
    type: null,
    path: '/:section',
    name: 'page-section',
    component: PageSection,
    title: 'Page Section'
  }, {
    type: 'getting-started',
    path: '/getting-started/quick-start',
    name: 'page-quick-start',
    component: PageQuickStart,
    title: 'Quick Start',
    icon: 'speedometer'
  }, {
    type: 'getting-started',
    path: '/content/bcq-app',
    name: 'page-bcq-app-getting-started',
    component: PageBcqApp,
    title: 'BCQ App',
    icon: 'apps'
  }, {
    type: 'getting-started',
    path: '/getting-started/bcq-bundler',
    name: 'page-bcq-bundler',
    component: PageBcqBundler,
    title: 'Bundler',
    icon: 'package-variant'
  }, {
    type: 'getting-started',
    path: '/getting-started/development',
    name: 'page-development',
    component: PageDevelopment,
    title: 'Developing the Library',
    icon: 'code-tags'
  }, {
    type: 'getting-started',
    path: '/getting-started/deployment',
    name: 'page-deployment',
    component: PageDeployment,
    title: 'Deploying this Website',
    icon: 'upload'
  }, {
    type: 'getting-started',
    path: '/getting-started/publishing',
    name: 'page-publishing',
    component: PagePublishing,
    title: 'Publishing the Library',
    icon: 'npm'
  }, {
    type: 'getting-started',
    path: '/getting-started/release-notes',
    name: 'page-release-notes',
    component: PageReleaseNotes,
    title: 'Release Notes',
    icon: 'message-text'
  }, {
    type: 'getting-started',
    path: '/roadmap',
    name: 'page-roadmap-getting-started',
    component: PageRoadmap,
    title: 'Roadmap',
    icon: 'road-variant'
  }, {
    type: 'content',
    path: '/content/bcq-app',
    name: 'page-bcq-app',
    component: PageBcqApp,
    title: 'BCQ App',
    icon: 'apps'
  }, {
    type: 'content',
    path: '/content/app-release-notes',
    name: 'page-app-release-notes',
    component: PageAppReleaseNotes,
    title: 'App Release Notes',
    icon: 'message-text'
  }, {
    type: 'content',
    path: '/directives/aspect-ratio',
    name: 'page-aspect-ratio-content',
    component: PageAspectRatio,
    title: 'Aspect Ratio',
    icon: 'move-resize'
  }, {
    type: 'content',
    path: '/content/barebone-prop',
    name: 'page-barebone-prop',
    component: PageBareboneProp,
    title: 'Barebone Prop',
    icon: 'creation'
  }, {
    type: 'content',
    path: '/content/brand-color',
    name: 'page-brand-color',
    component: PageBrandColor,
    title: 'Brand Color',
    icon: 'format-color-fill'
  }, {
    type: 'content',
    path: '/content/reusable-css-classes',
    name: 'page-reusable-css-classes',
    component: PageReusableCssClasses,
    title: 'CSS Helper Classes',
    icon: 'language-css3'
  }, {
    type: 'content',
    path: '/content/colors',
    name: 'page-colors',
    component: PageColors,
    title: 'Colors',
    icon: 'palette'
  }, {
    type: 'content',
    path: '/content/container',
    name: 'page-container',
    component: PageContainer,
    title: 'Container',
    icon: 'file-presentation-box'
  }, {
    type: 'content',
    path: '/content/elevation',
    name: 'page-elevation',
    component: PageElevation,
    title: 'Elevation and Shadows',
    icon: 'box-shadow'
  }, {
    type: 'content',
    path: '/content/flex',
    name: 'page-flex',
    component: PageFlex,
    title: 'Flex',
    icon: 'table-large'
  }, {
    type: 'content',
    path: '/content/meta-tags',
    name: 'page-meta-tags',
    component: PageMetaTags,
    title: 'Meta Tags',
    icon: 'tag'
  }, {
    type: 'content',
    path: '/content/navigator-online',
    name: 'page-navigator-online',
    component: PageNavigatorOnline,
    title: 'Navigator Online',
    icon: 'wifi'
  }, {
    type: 'content',
    path: '/ui/nightshift',
    name: 'page-nightshift-content',
    component: PageNightshift,
    title: 'Nightshift',
    icon: 'weather-night'
  }, {
    type: 'content',
    path: '/content/reactive-style',
    name: 'page-reactive-style',
    component: PageReactiveStyle,
    title: 'Reactive Style',
    icon: 'language-css3'
  }, {
    type: 'content',
    path: '/content/skeleton-loader',
    name: 'page-skeleton-loader',
    component: PageSkeletonLoader,
    title: 'Skeleton Loader',
    icon: 'apps'
  }, {
    type: 'content',
    path: '/content/spacing',
    name: 'page-spacing',
    component: PageSpacing,
    title: 'Spacing',
    icon: 'move-resize'
  }, {
    type: 'content',
    path: '/content/store',
    name: 'page-store',
    component: PageStore,
    title: 'Store',
    icon: 'database'
  }, {
    type: 'content',
    path: '/content/table-layout',
    name: 'page-table-layout',
    component: PageTableLayout,
    title: 'Table Layout',
    icon: 'grid'
  }, {
    type: 'content',
    path: '/content/theme',
    name: 'page-theme',
    component: PageTheme,
    title: 'Theme',
    icon: 'theme-light-dark'
  }, {
    type: 'content',
    path: '/content/theme-colors',
    name: 'page-theme-colors',
    component: PageThemeColors,
    title: 'Theme Colors',
    icon: 'format-color-fill'
  }, {
    type: 'content',
    path: '/content/typography',
    name: 'page-typography',
    component: PageTypography,
    title: 'Typography',
    icon: 'format-size'
  }, {
    type: 'content',
    path: '/content/visibility-observer',
    name: 'page-visibility-observer',
    component: PageVisibilityObserver,
    title: 'Visibility Observer',
    icon: 'eye'
  }, {
    type: 'ui',
    path: '/content/bcq-app',
    name: 'page-bcq-app-getting-started-ui',
    component: PageBcqApp,
    title: 'BCQ App',
    icon: 'apps'
  }, {
    type: 'ui',
    path: '/ui/alert',
    name: 'page-alert',
    component: PageAlert,
    title: 'Alert',
    icon: 'alert'
  }, {
    type: 'ui',
    path: '/ui/ambient-image',
    name: 'page-ambient-image',
    component: PageAmbientImage,
    title: 'Ambient Image',
    icon: 'image'
  }, {
    type: 'ui',
    path: '/ui/api-explorer',
    name: 'page-api-explorer',
    component: PageApiExplorer,
    title: 'API Explorer',
    icon: 'code-tags-check'
  }, {
    type: 'ui',
    path: '/ui/avatar',
    name: 'page-avatar',
    component: PageAvatar,
    title: 'Avatar',
    icon: 'account'
  }, {
    type: 'ui',
    path: '/ui/badge',
    name: 'page-badge',
    component: PageBadge,
    title: 'Badge',
    icon: 'label'
  }, {
    type: 'ui',
    path: '/ui/badge-generator',
    name: 'page-badge-generator',
    component: PageBadgeGenerator,
    title: 'Badge Generator',
    icon: 'label-outline'
  }, {
    type: 'ui',
    path: '/ui/banner',
    name: 'page-banner',
    component: PageBanner,
    title: 'Banner',
    icon: 'checkbox-blank'
  }, {
    type: 'ui',
    path: '/ui/bottom-navigation',
    name: 'page-bottom-navigation',
    component: PageBottomNavigation,
    title: 'Bottom Navigation',
    icon: 'page-layout-footer'
  }, {
    type: 'ui',
    path: '/ui/bottom-sheets',
    name: 'page-bottom-sheets',
    component: PageBottomSheets,
    title: 'Bottom Sheets',
    icon: 'page-layout-footer'
  }, {
    type: 'ui',
    path: '/ui/breadcrumbs',
    name: 'page-breadcrumbs',
    component: PageBreadcrumbs,
    title: 'Breadcrumbs',
    icon: 'navigation'
  }, {
    type: 'ui',
    path: '/ui/btn',
    name: 'page-btn',
    component: PageBtn,
    title: 'Button',
    icon: 'cursor-pointer'
  }, {
    type: 'ui',
    path: '/ui/btn-group',
    name: 'page-btn-group',
    component: PageBtnGroup,
    title: 'Button Group',
    icon: 'cursor-pointer'
  }, {
    type: 'ui',
    path: '/ui/card',
    name: 'page-card',
    component: PageCard,
    title: 'Card',
    icon: 'cards'
  }, {
    type: 'ui',
    path: '/ui/carousel',
    name: 'page-carousel',
    component: PageCarousel,
    title: 'Carousel',
    icon: 'view-carousel'
  }, {
    type: 'ui',
    path: '/ui/chip',
    name: 'page-chip',
    component: PageChip,
    title: 'Chip',
    icon: 'tag'
  }, {
    type: 'ui',
    path: '/ui/chessboard',
    name: 'page-chessboard',
    component: PageChessboard,
    title: 'Chessboard',
    icon: 'gamepad'
  }, {
    type: 'ui',
    path: '/ui/chord-diagram',
    name: 'page-chord-diagram',
    component: PageChordDiagram,
    title: 'Chord Diagram',
    icon: 'guitar-pick'
  }, {
    type: 'ui',
    path: '/ui/collapsible',
    name: 'page-collapsible',
    component: PageCollapsible,
    title: 'Collapsible',
    icon: 'format-line-spacing'
  }, {
    type: 'ui',
    path: '/ui/color-palette',
    name: 'page-color-palette',
    component: PageColorPalette,
    title: 'Color Palette',
    icon: 'format-color-fill'
  }, {
    type: 'ui',
    path: '/ui/color-picker',
    name: 'page-color-picker',
    component: PageColorPicker,
    title: 'Color Picker',
    icon: 'format-color-fill'
  }, {
    type: 'ui',
    path: '/ui/context-menu',
    name: 'page-context-menu',
    component: PageContextMenu,
    title: 'Context Menu',
    icon: 'chevron-down'
  }, {
    type: 'ui',
    path: '/ui/cookie-consent',
    name: 'page-cookie-consent',
    component: PageCookieConsent,
    title: 'Cookie Consent',
    icon: 'cookie'
  }, {
    type: 'ui',
    path: '/ui/data-table',
    name: 'page-data-table',
    component: PageDataTable,
    title: 'Data Table',
    icon: 'grid'
  }, {
    type: 'ui',
    path: '/ui/datetime-picker',
    name: 'page-datetime-picker',
    component: PageDatetimePicker,
    title: 'Datetime Picker',
    icon: 'calendar-clock'
  }, {
    type: 'ui',
    path: '/ui/dialog-box',
    name: 'page-dialog-box',
    component: PageDialogBox,
    title: 'Dialog Box',
    icon: 'window-restore'
  }, {
    type: 'ui',
    path: '/ui/divider',
    name: 'page-divider',
    component: PageDivider,
    title: 'Divider',
    icon: 'format-line-style'
  }, {
    type: 'ui',
    path: '/ui/emoji',
    name: 'page-emoji',
    component: PageEmoji,
    title: 'Emoji',
    icon: 'emoticon'
  }, {
    type: 'ui',
    path: '/ui/empty',
    name: 'page-empty',
    component: PageEmpty,
    title: 'Empty',
    icon: 'do-not-disturb'
  }, {
    type: 'ui',
    path: '/ui/fab',
    name: 'page-fab',
    component: PageFab,
    title: 'Floating Action Button',
    icon: 'cursor-pointer'
  }, {
    type: 'ui',
    path: '/ui/flag',
    name: 'page-flag',
    component: PageFlag,
    title: 'Flag',
    icon: 'flag'
  }, {
    type: 'ui',
    path: '/ui/gauge',
    name: 'page-gauge',
    component: PageGauge,
    title: 'Gauge',
    icon: 'gauge'
  }, {
    type: 'ui',
    path: '/ui/icon',
    name: 'page-icon',
    component: PageIcon,
    title: 'Icon',
    icon: 'emoticon'
  }, {
    type: 'ui',
    path: '/ui/inline-editor',
    name: 'page-inline-editor',
    component: PageInlineEditor,
    title: 'Inline Editor',
    icon: 'tooltip-edit'
  }, {
    type: 'ui',
    path: '/ui/lazy-image',
    name: 'page-lazy-image',
    component: PageLazyImage,
    title: 'Lazy Image',
    icon: 'image'
  }, {
    type: 'ui',
    path: '/ui/line-ripple',
    name: 'page-line-ripple',
    component: PageLineRipple,
    title: 'Line Ripple',
    icon: 'format-line-style'
  }, {
    type: 'ui',
    path: '/ui/list',
    name: 'page-list',
    component: PageList,
    title: 'List',
    icon: 'view-list'
  }, {
    type: 'ui',
    path: '/ui/loading-overlay',
    name: 'page-loading-overlay',
    component: PageLoadingOverlay,
    title: 'Loading Overlay',
    icon: 'reload'
  }, {
    type: 'ui',
    path: '/ui/lorem-ipsum',
    name: 'page-lorem-ipsum',
    component: PageLoremIpsum,
    title: 'Lorem Ipsum',
    icon: 'format-text'
  }, {
    type: 'ui',
    path: '/ui/macos-dock',
    name: 'page-macos-dock',
    component: PageMacosDock,
    title: 'MacOS Dock',
    icon: 'page-layout-footer'
  }, {
    type: 'ui',
    path: '/ui/menu-list',
    name: 'page-menu-list',
    component: PageMenuList,
    title: 'Menu List',
    icon: 'chevron-down'
  }, {
    type: 'ui',
    path: '/ui/multiline-ellipsis',
    name: 'page-multiline-ellipsis',
    component: PageMultilineEllipsis,
    title: 'Multiline Ellipsis',
    icon: 'cursor-text'
  }, {
    type: 'ui',
    path: '/ui/navbar',
    name: 'page-navbar',
    component: PageNavbar,
    title: 'Navbar',
    icon: 'navigation'
  }, {
    type: 'ui',
    path: '/ui/nightshift',
    name: 'page-nightshift',
    component: PageNightshift,
    title: 'Nightshift',
    icon: 'weather-night'
  }, {
    type: 'ui',
    path: '/ui/notification',
    name: 'page-notification',
    component: PageNotification,
    title: 'Notification',
    icon: 'notification-clear-all'
  }, {
    type: 'ui',
    path: '/ui/pager',
    name: 'page-pager',
    component: PagePager,
    title: 'Pager',
    icon: 'page-last'
  }, {
    type: 'ui',
    path: '/ui/parallax',
    name: 'page-parallax',
    component: PageParallax,
    title: 'Parallax',
    icon: 'projector-screen'
  }, {
    type: 'ui',
    path: '/ui/password-generator',
    name: 'page-password-generator',
    component: PagePasswordGenerator,
    title: 'Password Generator',
    icon: 'lock'
  }, {
    type: 'ui',
    path: '/ui/password-strength-meter',
    name: 'page-password-strength-meter',
    component: PagePasswordStrengthMeter,
    title: 'Password Strength Meter',
    icon: 'gauge'
  }, {
    type: 'ui',
    path: '/ui/progressbar',
    name: 'page-progressbar',
    component: PageProgressbar,
    title: 'Progressbar',
    icon: 'loading'
  }, {
    type: 'ui',
    path: '/ui/qr-code',
    name: 'page-qr-code',
    component: PageQrCode,
    title: 'QR Code',
    icon: 'qrcode'
  }, {
    type: 'ui',
    path: '/ui/rating',
    name: 'page-rating',
    component: PageRating,
    title: 'Rating',
    icon: 'star'
  }, {
    type: 'ui',
    path: '/ui/reflection',
    name: 'page-reflection',
    component: PageReflection,
    title: 'Reflection',
    icon: 'flip-to-front'
  }, {
    type: 'ui',
    path: '/ui/ribbon',
    name: 'page-ribbon',
    component: PageRibbon,
    title: 'Ribbon',
    icon: 'tab'
  }, {
    type: 'ui',
    path: '/ui/slider',
    name: 'page-slider',
    component: PageSlider,
    title: 'Slider',
    icon: 'ray-vertex'
  }, {
    type: 'ui',
    path: '/ui/snackbar',
    name: 'page-snackbar',
    component: PageSnackbar,
    title: 'Snackbar',
    icon: 'notification-clear-all'
  }, {
    type: 'ui',
    path: '/ui/social-bar',
    name: 'page-social-bar',
    component: PageSocialBar,
    title: 'Social Bar',
    icon: 'share-variant'
  }, {
    type: 'ui',
    path: '/ui/sparklines',
    name: 'page-sparklines',
    component: PageSparklines,
    title: 'Sparklines',
    icon: 'chart-line-variant'
  }, {
    type: 'ui',
    path: '/ui/stats',
    name: 'page-stats',
    component: PageStats,
    title: 'Stats',
    icon: 'chart-timeline'
  }, {
    type: 'ui',
    path: '/ui/stepper',
    name: 'page-stepper',
    component: PageComingSoon,
    title: 'Stepper',
    icon: 'step-forward',
    hidden: true
  }, {
    type: 'ui',
    path: '/ui/steps',
    name: 'page-steps',
    component: PageSteps,
    title: 'Steps',
    icon: 'step-forward'
  }, {
    type: 'ui',
    path: '/ui/system-bar',
    name: 'page-system-bar',
    component: PageSystemBar,
    title: 'System Bar',
    icon: 'android'
  }, {
    type: 'ui',
    path: '/ui/tab',
    name: 'page-tab',
    component: PageTab,
    title: 'Tab',
    icon: 'tab'
  }, {
    type: 'ui',
    path: '/ui/terminal',
    name: 'page-terminal',
    component: PageTerminal,
    title: 'Terminal',
    icon: 'console'
  }, {
    type: 'ui',
    path: '/ui/timeline',
    name: 'page-timeline',
    component: PageTimeline,
    title: 'Timeline',
    icon: 'chart-timeline'
  }, {
    type: 'ui',
    path: '/ui/time-picker',
    name: 'page-time-picker',
    component: PageTimePicker,
    title: 'Time Picker',
    icon: 'timetable'
  }, {
    type: 'ui',
    path: '/ui/toolbar',
    name: 'page-toolbar',
    component: PageToolbar,
    title: 'Toolbar',
    icon: 'page-layout-header'
  }, {
    type: 'ui',
    path: '/ui/transfer',
    name: 'page-transfer',
    component: PageTransfer,
    title: 'Transfer',
    icon: 'transfer'
  }, {
    type: 'ui',
    path: '/ui/treeview',
    name: 'page-treeview',
    component: PageTreeview,
    title: 'Treeview',
    icon: 'file-tree'
  }, {
    type: 'ui',
    path: '/ui/vid',
    name: 'page-vid',
    component: PageVid,
    title: 'Vid',
    icon: 'video'
  }, {
    type: 'ui',
    path: '/ui/visual-feedback-icon',
    name: 'page-visual-feedback-icon',
    component: PageVisualFeedbackIcon,
    title: 'Visual Feedback Icon',
    icon: 'emoticon'
  }, {
    type: 'forms',
    path: '/forms/async-form',
    name: 'page-async-form',
    component: PageAsyncForm,
    title: 'Async Form',
    icon: 'cards-variant'
  }, {
    type: 'forms',
    path: '/forms/autocomplete',
    name: 'page-autocomplete',
    component: PageAutocomplete,
    title: 'Autocomplete',
    icon: 'cursor-text'
  }, {
    type: 'forms',
    path: '/ui/btn',
    name: 'page-btn-forms',
    component: PageBtn,
    title: 'Button',
    icon: 'cursor-pointer'
  }, {
    type: 'forms',
    path: '/forms/checkbox',
    name: 'page-checkbox',
    component: PageCheckbox,
    title: 'Checkbox',
    icon: 'checkbox-marked'
  }, {
    type: 'forms',
    path: '/forms/chip-input',
    name: 'page-chip-input',
    component: PageChipInput,
    title: 'Chip Input',
    icon: 'tag'
  }, {
    type: 'forms',
    path: '/forms/clustered-list',
    name: 'page-clustered-list',
    component: PageClusteredList,
    title: 'Clustered List',
    icon: 'arrow-down-drop-circle'
  }, {
    type: 'forms',
    path: '/forms/clustered-list-2',
    name: 'page-clustered-list-2',
    component: PageClusteredList2,
    title: 'Clustered List 2',
    icon: 'arrow-down-drop-circle'
  }, {
    type: 'forms',
    path: '/ui/color-picker',
    name: 'page-color-picker-forms',
    component: PageColorPicker,
    title: 'Color Picker',
    icon: 'format-color-fill'
  }, {
    type: 'forms',
    path: '/forms/dropdown',
    name: 'page-dropdown',
    component: PageDropdown,
    title: 'Dropdown',
    icon: 'arrow-down-drop-circle'
  }, {
    type: 'forms',
    path: '/forms/form-group',
    name: 'page-form-group',
    component: PageFormGroup,
    title: 'Form Group',
    icon: 'group'
  }, {
    type: 'forms',
    path: '/forms/form-schema',
    name: 'page-form-schema',
    component: PageFormSchema,
    title: 'Form Schema',
    icon: 'database'
  }, {
    type: 'forms',
    path: '/forms/otp-input',
    name: 'page-otp-input',
    component: PageOtpInput,
    title: 'OTP Input',
    icon: 'lock'
  }, {
    type: 'forms',
    path: '/forms/radio-group',
    name: 'page-radio-group',
    component: PageRadioGroup,
    title: 'Radio Group',
    icon: 'radiobox-marked'
  }, {
    type: 'forms',
    path: '/ui/rating',
    name: 'page-rating-forms',
    component: PageRating,
    title: 'Rating',
    icon: 'star'
  }, {
    type: 'forms',
    path: '/ui/slider',
    name: 'page-slider-forms',
    component: PageSlider,
    title: 'Slider',
    icon: 'ray-vertex'
  }, {
    type: 'forms',
    path: '/forms/switcher',
    name: 'page-switcher',
    component: PageSwitcher,
    title: 'Switcher',
    icon: 'toggle-switch'
  }, {
    type: 'forms',
    path: '/forms/text-field',
    name: 'page-text-field',
    component: PageTextField,
    title: 'Text Field',
    icon: 'cursor-text'
  }, {
    type: 'forms',
    path: '/ui/time-picker',
    name: 'page-time-picker-forms',
    component: PageTimePicker,
    title: 'Time Picker',
    icon: 'timetable'
  }, {
    type: 'forms',
    path: '/forms/time-picker-field',
    name: 'page-time-picker-field',
    component: PageTimePickerField,
    title: 'Time Picker Field',
    icon: 'timetable'
  }, {
    type: 'forms',
    path: '/forms/upload',
    name: 'page-upload',
    component: PageUpload,
    title: 'Upload',
    icon: 'cloud-upload'
  }, {
    type: 'directives',
    path: '/directives/aspect-ratio',
    name: 'page-aspect-ratio',
    component: PageAspectRatio,
    title: 'Aspect Ratio',
    icon: 'move-resize'
  }, {
    type: 'directives',
    path: '/directives/gradient-text',
    name: 'page-gradient-text',
    component: PageGradientText,
    title: 'Gradient Text',
    icon: 'gradient'
  }, {
    type: 'directives',
    path: '/directives/intersect',
    name: 'page-intersect',
    component: PageIntersect,
    title: 'Intersect',
    icon: 'vector-intersection'
  }, {
    type: 'directives',
    path: '/directives/resize',
    name: 'page-resize',
    component: PageResize,
    title: 'Resize',
    icon: 'format-size'
  }, {
    type: 'directives',
    path: '/directives/ripple',
    name: 'page-ripple',
    component: PageRipple,
    title: 'Ripple',
    icon: 'blur'
  }, {
    type: 'directives',
    path: '/directives/tooltip',
    name: 'page-tooltip',
    component: PageTooltip,
    title: 'Tooltip',
    icon: 'tooltip'
  }, {
    path: '*',
    redirect: '/'
  }]
})



// WEBPACK FOOTER //
// ./src/helpers/router.js